import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SingleSelect, SingleSelectData } from 'suomifi-ui-components'
import { MaritalStatus } from 'todistukset-common/src/vtj/MaritalStatus.enum'
import {
  finalEditableFieldValue,
  Siviilisaaty,
} from 'todistukset-common/src/vtj/types/editable-field.type'
import { useAriaOptionsFunction } from 'todistukset-ui/src/vtj/components/order-wizard/country-select.util'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'

interface MaritalStatusSelectProps {
  maritalStatus: Siviilisaaty | null
  setMaritalStatus: (
    selectedItem: (SingleSelectData & { uniqueItemId: MaritalStatus }) | null
  ) => void
  maritalStatusRef: React.RefObject<HTMLInputElement>
  errorStatus: {
    status: 'default' | 'error'
    statusText?: string
  }
}

export const MaritalStatusSelect: React.FC<MaritalStatusSelectProps> = ({
  maritalStatus,
  setMaritalStatus,
  maritalStatusRef,
  errorStatus,
}) => {
  const { t } = useTranslation()
  const {
    common: { lang },
  } = useStore()

  const maritalStatusSelectItems: (SingleSelectData & {
    uniqueItemId: MaritalStatus
  })[] = useMemo(
    () => [
      {
        labelText: t(`maritalStatus_${MaritalStatus.NAIMATON}`),
        uniqueItemId: MaritalStatus.NAIMATON,
      },
      {
        labelText: t(`maritalStatus_${MaritalStatus.ERONNUT}`),
        uniqueItemId: MaritalStatus.ERONNUT,
      },
      {
        labelText: t(`maritalStatus_${MaritalStatus.LESKI}`),
        uniqueItemId: MaritalStatus.LESKI,
      },
    ],
    [lang] // eslint-disable-line react-hooks/exhaustive-deps
  )
  const maritalStatusSelectedItem = maritalStatusSelectItems.find(
    (item) => item.uniqueItemId === finalEditableFieldValue(maritalStatus)
  )

  const ariaOptionsFunction = useAriaOptionsFunction()

  return (
    <SingleSelect
      id="select-marital-status-widget"
      data-test-id="single-select-marital-status"
      labelText={t('aetOwnInfoMaritalStatusLabel')}
      visualPlaceholder={t('aetOwnInfoMaritalStatusPrompt')}
      items={maritalStatusSelectItems}
      clearButtonLabel={t('orderWizardSingleSelectClearSelection')}
      noItemsText={t('orderWizardSingleSelectNoMatchingItems')}
      ariaOptionsAvailableTextFunction={ariaOptionsFunction}
      selectedItem={maritalStatusSelectedItem}
      onItemSelectionChange={setMaritalStatus}
      {...errorStatus}
      forwardedRef={maritalStatusRef}
    />
  )
}
